<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingright: 0; padding-bottom: 0">
      <el-form :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="text">
              <el-input v-model="form.text" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="志愿者状态 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in levelList" :key="item.dictCode" :label="item.dictName"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="注册时间 :" prop="time">
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px; top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <!-- <el-button class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;导入
          </el-button> -->

          <el-button @click="exportList" :class="{ 'el-primary-border': chooseRowIds }" :disabled="!chooseRowIds">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button>

          <el-button @click="exportTime" :class="{ 'el-primary-border': chooseRowIds }" :disabled="!chooseRowIds">
            <svg-icon icon-class="add" />&nbsp;导出时长
          </el-button>

          <el-button @click="exportDetail">
            <svg-icon icon-class="add" />&nbsp;导出统计明细
          </el-button>
        </el-row>
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" @selection-change="handleSelectionChange" stripe
          :data="tableData">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="6%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sex" label="性别" min-width="5%" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.sex | filterSex }}</span></template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" min-width="7%"></el-table-column>
          <el-table-column prop="registrationTime" sortable label="注册时间" min-width="7%">
            <template slot-scope="scope"><span>{{
              scope.row.registrationTime | filterTime
            }}</span></template>
          </el-table-column>
          <el-table-column prop="volunteerStatus" label="志愿者状态" min-width="7%">
            <template slot-scope="scope"><span>{{
              scope.row.volunteerStatus | filterVolunteerStatus(that)
            }}</span></template>
          </el-table-column>
          <el-table-column prop="explanationNum" sortable label="讲解场次" min-width="7%">
            <template slot-scope="scope"><span style="color: #0672b7; cursor: pointer"
                @click="viewExplainSessions(scope.row.id)">{{ scope.row.explanationNum }}</span></template>
          </el-table-column>
          <el-table-column prop="explanationDuration" sortable label="讲解时长" min-width="7%">
            <template slot-scope="scope"><span>{{ scope.row.explanationDuration }}</span></template>
          </el-table-column>

          <el-table-column prop="numberActivities" sortable label="折合讲解场次" min-width="8%">
            <template slot-scope="scope"><span style="color: #0672b7; cursor: pointer"
                @click="viewActivities(scope.row.id)">{{ scope.row.numberActivities }}</span></template>
          </el-table-column>

          <el-table-column prop="activitiesTime" sortable label="活动时长" min-width="7%">
            <template slot-scope="scope"><span>{{ scope.row.activitiesTime || 0 }}</span></template>
          </el-table-column>

          <el-table-column prop="totalServiceNum" sortable label="服务总场次" min-width="7%">
            <template slot-scope="scope"><span>{{ scope.row.totalServiceNum }}</span></template>
          </el-table-column>

          <el-table-column prop="totalServiceTime" sortable label="服务总时长" min-width="7%">
            <template slot-scope="scope"><span>{{ scope.row.totalServiceTime }}小时</span></template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="showDetail(scope.row.id)">查看</a>
              <a class="m-btn mr-10" @click="handlerEdit(scope.row.id)">编辑</a>
              <a class="m-btn mr-10" v-if="scope.row.volunteerStatus == 1"
                @click="handleInterViewResult(scope.row)">转正</a>
              <a class="m-btn m-danger mr-10" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog class="dialog-volunteer-detail" :append-to-body="true" @close="cancel2" :visible.sync="dialogVisible2"
      title="导出统计明细" width="600px">
      <el-form class="g-form-grid" ref="detailForm" :model="detailForm" :rules="rules" label-width="120px">
        <el-form-item label="时间区间 :" prop="time">
          <el-date-picker start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%" v-model="detailForm.time"
            value-format="yyyy-MM-dd" type="daterange" range-separator="至"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel2">取 消</el-button>
        <el-button type="primary" @click="submit2">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看活动场次 -->
    <!-- <el-dialog title="查看活动场次" :visible.sync="dialogVisible" width="60%" :before-close="beforeClose">
      <el-table ref="multipleTable" stripe :data="activitiesTableData">
        <el-table-column prop="activityDate" label="活动日期" min-width="10%"></el-table-column>
        <el-table-column prop="serviceName" label="活动名称" min-width="10%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="serviceTime" label="服务时间" min-width="10%"></el-table-column>
        <el-table-column prop="realServiceTime" label="服务时长" min-width="10%"></el-table-column>
        <el-table-column prop="explainNum" label="折合讲解场次" min-width="10%"></el-table-column>
      </el-table>
    </el-dialog> -->

    <!-- 查看讲解场次 -->
    <!-- <el-dialog title="查看讲解场次" :visible.sync="dialogVisible1" width="60%" :before-close="beforeClose1">
      <el-table ref="multipleTable" stripe :data="explainTableData">
        <el-table-column prop="activityTime" label="活动日期" min-width="10%"></el-table-column>
        <el-table-column prop="activityName" label="活动名称" min-width="10%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="serviceTime" label="服务时间" min-width="10%"></el-table-column>
        <el-table-column prop="serviceDuration" label="服务时长" min-width="10%"></el-table-column>
        <el-table-column prop="sessions" label="折合讲解场次" min-width="10%"></el-table-column>
      </el-table>
    </el-dialog> -->

    <dialogVolunteerDetail ref="dialogVolunteerDetail" @refresh="restList"></dialogVolunteerDetail>
  </div>
</template>

<script>
import dialogVolunteerDetail from './dialog-volunteer-detail'

export default {
  components: {
    dialogVolunteerDetail
  },
  data() {
    return {
      that: this,
      form: {
        text: '',
        status: '',
        time: ''
      },
      listLoading: true,
      tableData: [],
      activitiesTableData: [],
      explainTableData: [],
      levelList: [
        { dictCode: '1', dictName: '预备志愿者' },
        { dictCode: '2', dictName: '正式志愿者' }
      ],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      detailForm: {
        time: ''
      },
      rules: {
        time: [{ required: true, message: '时间区间不能为空', trigger: 'blur' }]
      },
      chooseRowIds: '',
      total: 0,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false
    }
  },

  filters: {
    filterSex(type) {
      if (type == 1) {
        return '男'
      }
      if (type == 0) {
        return '女'
      }
      return ''
    },

    filterVolunteerStatus(status, that) {
      let obj = that.levelList.filter((item) => {
        return item.dictCode == status
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterTime(time) {
      return time.slice(0, 10)
    }
  },

  methods: {
    // 获取下拉状态选择值
    // getDropdownValue() {
    //   this.$http
    //     .post('/collectDict/getSelectDataByArr', {
    //       arr: ['volunteer_status']
    //     })
    //     .then(res => {
    //       if (res.success) {
    //         var state = res.result
    //         let firstArr = [{ dictCode: null, dictName: '全部' }]
    //         this.levelList = firstArr.concat(state['volunteer_status'])
    //       }
    //     })
    // },

    exportDetail() {
      this.dialogVisible2 = true
    },

    cancel2() {
      this.dialogVisible2 = false
      this.$refs['detailForm'].resetFields()
    },

    submit2() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          location.href = '/singleMuseum/v2/bsVolunteerV2Adult/exportAllAdult?beginTime=' + this.detailForm.time[0] + '&endTime=' + this.detailForm.time[1]
        }
      })
    },

    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要导出的志愿者')
        return
      }
      location.href =
        '/singleMuseum/v2/bsVolunteerV2Adult/export?ids=' +
        this.chooseRowIds +
        '&status=1,2'
      // this.$api.volunteer.exportAdultList({ids:this.chooseRowIds}).then(res=>{
      //   console.log(res)
      // })
    },

    exportTime() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要导出的志愿者')
        return
      }
      location.href =
        '/singleMuseum/v2/bsVolunteerV2Adult/exportDuration?ids=' +
        this.chooseRowIds +
        '&type=1'
    },

    initData() {
      this.listLoading = true
      this.$api.volunteer
        .getVolunteerAdultList({
          ...this.form,
          status: this.form.status ? this.form.status : '1, 2',
          ...this.listQuery
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.listLoading = false
        })
    },

    // 详情
    showDetail(item) {
      this.$refs.dialogVolunteerDetail.init(item, 'detail', '2')
    },
    handlerEdit(item) {
      this.$refs.dialogVolunteerDetail.init(item, '', '2')
    },
    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `您正在删除${obj.name}志愿者，是否确认删除？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer.deleteAdult({ id: obj.id }).then((res) => {
            if (res.success) {
              this.$message.success('志愿者删除成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },
    getTableList() {
      this.initData()
    },

    restList() {
      this.$refs.form.resetFields()
      this.listQuery.currentPage = 1
      this.initData()
    },

    viewActivities(id) {
      this.$router.push({
        path: '/volunteer/service-list',
        query: { id: id }
      })
      // this.$api.volunteer.getViewActivity({ id: id }).then(res => {
      //   if (res.success) {
      //     if (res.result && res.result.length > 0) {
      //       this.dialogVisible = true
      //       this.activitiesTableData = res.result
      //     } else {
      //       this.$message.warning('暂无活动场次')
      //     }
      //   }
      // })
    },

    viewExplainSessions(id) {
      this.$router.push({
        path: '/volunteer/exlain-index',
        query: { id: id }
      })
      // this.$api.volunteer.getViewexplain({ id: id }).then(res => {
      //   if (res.success) {
      //     if (res.result && res.result.length > 0) {
      //       this.dialogVisible1 = true
      //       this.explainTableData = res.result

      //     } else {
      //       this.$message.warning('暂无讲解场次')
      //     }
      //   }
      // })
    },

    beforeClose() {
      this.dialogVisible = false
    },

    beforeClose1() {
      this.dialogVisible1 = false
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    handleInterView() { },
    handleInterViewResult(obj) {
      this.$common.confirm(
        {
          title: `是否将${obj.name}志愿者转正？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer
            .becomeRegularWorker({ id: obj.id })
            .then((res) => {
              if (res.success) {
                this.$message.success('转正成功')
                this.initData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach((item) => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },

  mounted() {
    this.initData()
    window.addEventListener('keyup', this.keydown)

    // this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}

.el-form-state {
  /deep/ .el-form-item__label {
    width: 100px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 100px !important;
  }
}
</style>